import _ from 'lodash';
export class TwoColumnsComponent {
    key;
    label;
    title;
    type;
    columns;
    constructor(config = {}, component1, component2) {
        this.key = `TwoColumns${config.key ? `-${config.key}` : ''}`;
        this.label = config.label || _.startCase(config.key);
        this.title = this.label;
        this.type = 'columns';
        this.columns = [
            {
                components: [
                    {
                        ...component1,
                    }
                ],
                width: 6,
                size: 'md'
            },
            {
                components: [
                    {
                        ...component2,
                    }
                ],
                width: 6,
                size: 'md'
            }
        ];
    }
}
